import { Tab } from '@mui/material'
import { styled } from '@mui/material'
import { colors } from '../theme/colors.theme'

export const tabTheme = {
  root: {
    minWidth: 'auto !important',
    marginRight: 30,
    padding: '0 10px 10px 10px',
    minHeight: 10,
    textTransform: 'none' as 'none',
    fontWeight: 'bold' as 'bold',
    '&.Mui-selected': {
      opacity: '1 !important',
      color: colors.primary,
    },
  },
}

export const TabIcon = styled(Tab)({
  root: {
    padding: '6px 10px',
    margin: 0,
    marginRight: 1,
    borderRadius: '4px 4px 0px 0px',
    '&.Mui-disabled': {
      opacity: '0.5 !important',
    },
  },
  wrapper: {
    flexDirection: 'row',
  },
  labelIcon: {
    minHeight: 0,
    '& .MuiTab-wrapper > *:first-of-type': {
      margin: '0 6px 0 0',
    },
  },
})

export const TabLanguageIcon = styled(Tab)({
  root: {
    padding: '6px 10px',
    margin: 0,
    marginRight: 1,
    borderRadius: '4px 4px 0px 0px',
    '&.Mui-disabled': {
      opacity: '0.5 !important',
    },
  },
  wrapper: {
    flexDirection: 'row',
  },
  labelIcon: {
    minHeight: 0,
    '& .MuiTab-wrapper > *:first-child': {
      margin: '0 6px 0 0',
    },
  },
})
